import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ListedUser } from '@/lib/api';

// =============================================================================
// Users store — cache hasil userList() di session (persisted ke localStorage).
// Tujuan: resolve nama user (mis. di topbar impersonation badge) tanpa request
// ulang ke backend setiap mount. Refresh eksplisit via UserPicker dialog.
// =============================================================================

interface UsersState {
  /** Cache rows hasil userList terakhir. */
  rows: ListedUser[];
  /** Epoch ms saat cache di-set. */
  loadedAt: number | null;

  /** Set cache (dipanggil oleh UserPicker setelah fetch sukses). */
  setRows: (rows: ListedUser[]) => void;
  /** Cari user by id di cache (sync, tidak fetch). */
  findById: (id: number) => ListedUser | undefined;
  /** Hapus cache (mis. saat logout). */
  clear: () => void;
}

export const useUsersStore = create<UsersState>()(
  persist(
    (set, get) => ({
      rows: [],
      loadedAt: null,

      setRows: (rows) => set({ rows, loadedAt: Date.now() }),

      findById: (id) => get().rows.find((u) => u.id === id),

      clear: () => set({ rows: [], loadedAt: null }),
    }),
    {
      name: 'webgps-users-cache',
    },
  ),
);
